import { Pipeline as CommonPipeline } from 'modules/Common/Fields'

export const Pipeline = () => {
  return <CommonPipeline data-testid="edit-schedule-pipeline" />
}
